export const BankOfferIcons = {
	CHAPTER_PASS: 'chapter_pass',
	KEY_SINGLE: 'key_single',
	KEY_SET: 'key_set',
	KEY_SET_HEAVY: 'key_set_heavy',
	KEY_CHEST: 'key_chest',
	KEY_CHEST_MANY: 'key_chests',
	TICKET_SINGLE: 'ticket_single',
	TICKET_SET: 'ticket_set',
	TICKET_STRIPS: 'ticket_strips',
	TICKET_REELS: 'ticket_reels',
	GIFT_N_KEY: 'gift_n_key',
	GIFT_N_TICKET: 'gift_n_ticket',
	PACK_BRONZE: 'pack_bronze',
	PACK_SILVER: 'pack_silver',
	PACK_GOLD: 'pack_gold',
	PACK_DIAMOND: 'pack_diamond',
	GIFT: 'gift', // "Default"

	PACK_HALLOWEEN: 'pack_halloween',
	PACK_CHRISTMAS: 'pack_christmas',
	PACK_VALENTINES_DAY: 'pack_valentines_day',
} as const

export const bankOfferIcons = Object.values(BankOfferIcons)
export type BankOfferIcon = (typeof BankOfferIcons)[keyof typeof BankOfferIcons]

export const bankOfferIconLabels: Record<BankOfferIcon, string> = {
	chapter_pass: 'Pass chapitre',
	key_single: 'Une clé',
	key_set: 'Trousseau de clés',
	key_set_heavy: 'Gros trousseau de clés',
	key_chest: 'Coffre de clés',
	key_chests: 'Plusieurs coffres de clés',
	ticket_single: 'Un ticket',
	ticket_set: 'Plusieurs tickets',
	ticket_strips: 'Bandes de tickets',
	ticket_reels: 'Rouleaux de tickets',
	pack_bronze: 'Pack bronze',
	pack_silver: 'Pack argent',
	pack_gold: 'Pack or',
	pack_diamond: 'Pack diamant',
	gift: 'Cadeau',
	gift_n_key: 'Cadeau + clé',
	gift_n_ticket: 'Cadeau + ticket',

	pack_halloween: 'Pack Halloween',
	pack_christmas: 'Pack Noël',
	pack_valentines_day: 'Pack Saint Valentin',
}
